import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export type ComponentTableDeleteConfirmDialogProps = {
  open: boolean
  title: string
  description: string
  deleteDisabled: boolean
  onCancel: () => void
  onConfirmDelete: () => void
}

export function ComponentTableDeleteConfirmDialog({
  open,
  title,
  description,
  deleteDisabled,
  onCancel,
  onConfirmDelete,
}: ComponentTableDeleteConfirmDialogProps) {
  return (
    <Dialog open={open} modal={true}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 mt-4">
          <Button variant="outline" onClick={onCancel} type="button" className="w-full">
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirmDelete}
            type="button"
            className="w-full"
            disabled={deleteDisabled}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
